import { observer } from "mobx-react-lite"
import React, { useEffect, useRef, useState } from "react";
import gsap from 'gsap';

const SwitcherStage = ({ name1, name2, onChangeValue, backIsWhite, onClickFirst, onClickSecond, defaultValue }) => {
    const [isFirst, setIsFirst] = useState(defaultValue != undefined ? defaultValue : true);
    const param1 = useRef(null);
    const param2 = useRef(null);
    const background = useRef(null);

    useEffect(() => toggleValue(false), []);

    const toggleValue = (value) => {
        if (isFirst != value) setIsFirst(value);
        // onChangeValue(value);

        const firstRect = param1.current.getBoundingClientRect();
        const secondRect = param2.current.getBoundingClientRect();

        const targetWidth = value ? secondRect.width : firstRect.width;
        const targetX = value ? secondRect.left - firstRect.left : 0;

        gsap.to(background.current, {
            x: targetX,
            width: targetWidth,
            duration: .15,
            ease: 'power2.inOut',
        });
    }

    return (
        <ul className={backIsWhite ? "switcher dark" : "switcher"}>
            <div ref={background} className="bg"></div>
            <li ref={param1} onClick={() => { toggleValue(false); onClickFirst() }} className={`${isFirst ? "" : "active"}`}>{name1}</li>
            <li ref={param2} onClick={() => { toggleValue(true); onClickSecond() }}  className={`${isFirst ? "active" : ""}`}>{name2}</li>
        </ul>
    )
}

export default observer(SwitcherStage);